import React from 'react';
interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}
export function ChartCard({
  title,
  children,
  action,
  className = ''
}: ChartCardProps) {
  return <div className={`bg-white rounded-lg shadow-sm border border-slate-200 p-6 ${className}`} data-id="element-94">
      <div className="flex justify-between items-center mb-6" data-id="element-95">
        <h3 className="text-lg font-semibold text-slate-800" data-id="element-96">{title}</h3>
        {action && <div data-id="element-97">{action}</div>}
      </div>
      <div className="w-full" data-id="element-98">{children}</div>
    </div>;
}